export default "__VITE_ASSET__c6f693bb__"